module.exports = __webpack_public_path__ + "static/media/trophy.4bee6467.svg";